export const colors = [0xef007f, 0x8700ff, 0x009dff, 0x88c613, 0xff9114];
